const { createTheme } = require('@mui/material');

const theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: 'Poppins, sans-serif',
    },

    pageTitle: {
      fontSize: '26px',
      fontWeight: 600,

      '@media (max-width: 991px)': {
        fontSize: '26px',
      },

      '@media (max-width: 768px)': {
        fontSize: '24px',
      },

      '@media (max-width: 576px)': {
        fontSize: '22px',
      },
    },
  },

  components: {
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          pageTitle: 'h1',
        },
      },
    },
    MuiDivider: {
      defaultProps: {
        color: 'grey',
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '28px',
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          maxWidth: '1400px !important',
        },
      },
    },
  },

  breakpoints: {
    values: {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
      xxl: 1400,
    },
  },

  palette: {
    primary: {
      main: '#259245',
      contrastText: '#ffffff',
    },
    themeDark: {
      main: '#252b36',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#3c3c3c',
      contrastText: '#fff',
    },
    whiteColor: {
      main: '#FFFFFF',
    },
    mutedColor: {
      main: '#e4e4e4',
      contrastText: '#000',
    },
    purpleColor: {
      main: '#875f8e',
      contrastText: '#fff',
    },
    seeGreenColor: {
      main: '#049aad',
      contrastText: '#fff',
    },
  },
});

export default theme;
